import type { EdgeServer } from '../types'
import { Lamp, type LampState } from './Lamp'
import { LAMP_TEXT, serverLamp } from './serverLamp'

/** 자원 사용률 막대 — 70% 이상 황색, 90% 이상 적색 */
export function UsageBar({ label, value }: { label: string; value: number }) {
  const pct = Math.round(value)
  const color = pct >= 90 ? 'bg-lamp-fault' : pct >= 70 ? 'bg-lamp-warn' : 'bg-gray-500'
  return (
    <div className="flex items-center gap-2.5 min-w-0">
      <span className="w-9 text-xs text-gray-500 shrink-0">{label}</span>
      <div className="flex-1 h-1 rounded-sm bg-gray-200/80 overflow-hidden">
        <div className={`h-full rounded-sm ${color} transition-[width] duration-500`} style={{ width: `${Math.min(100, pct)}%` }} />
      </div>
      <span className="w-10 text-right tabular text-xs font-medium text-gray-700 shrink-0">{pct}%</span>
    </div>
  )
}

/**
 * 램프 보드 — 전체 서버의 온라인 수와 상태별 개수를 한눈에 본다.
 * 서버별 램프는 바로 아래 서버 카드가 이미 보여주므로 여기서는 집계만 한다.
 */
export function LampBoard({ servers, aside }: {
  servers: EdgeServer[]
  aside?: React.ReactNode
}) {
  const counts: Record<LampState, number> = { run: 0, warn: 0, fault: 0, off: 0 }
  servers.forEach(s => { counts[serverLamp(s)]++ })
  const online = servers.length - counts.off

  return (
    <section className="bg-surface rounded-xl border border-gray-200 px-6 py-5 mb-8" aria-label="서버 상태 요약">
      <div className="flex flex-wrap items-baseline justify-between gap-x-8 gap-y-2">
        <p className="text-gray-600">
          서버 <span className="tabular text-2xl font-semibold text-gray-900 tracking-tight">{servers.length}</span>대 중{' '}
          <span className="tabular text-2xl font-semibold text-gray-900 tracking-tight">{online}</span>대 온라인
        </p>
        {aside && <div className="text-[13px] text-gray-500">{aside}</div>}
      </div>

      <ul className="mt-4 flex flex-wrap gap-x-6 gap-y-1 text-[13px] text-gray-600">
        {(['run', 'fault', 'warn', 'off'] as const).map(k => (
          <li key={k} className="inline-flex items-center gap-2">
            <Lamp state={k} className="!w-1.5 !h-1.5" />
            {LAMP_TEXT[k]} <span className="tabular font-semibold text-gray-900">{counts[k]}</span>
          </li>
        ))}
      </ul>
    </section>
  )
}
